/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_Meta_TitleInputs */

const en_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame | Mark Egly Golf`)
};

const es_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salón de la fama | Mark Egly Golf`)
};

const de_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhmeshalle | Mark Egly Golf`)
};

const zh_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`名人堂 | Mark Egly Golf`)
};

const ar_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قاعة المشاهير | Mark Egly Golf`)
};

const fr_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temple de la renommée | Mark Egly Golf`)
};

const vi_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đại sảnh danh vọng | Mark Egly Golf`)
};

const sw_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jumba la Umaarufu | Mark Egly Golf`)
};

const th_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หอเกียรติยศ | Mark Egly Golf`)
};

const bs_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuća slavnih | Mark Egly Golf`)
};

const ja_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`殿堂 | Mark Egly Golf`)
};

const ko_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명예의 전당 | Mark Egly Golf`)
};

const pt_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall da Fama | Mark Egly Golf`)
};

const it_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame | Mark Egly Golf`)
};

const sv_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame | Mark Egly Golf`)
};

const nl_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalerij | Mark Egly Golf`)
};

const da_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame | Mark Egly Golf`)
};

const nb_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hall of Fame | Mark Egly Golf`)
};

const fi_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunniagalleria | Mark Egly Golf`)
};

const pl_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeria sław | Mark Egly Golf`)
};

const ru_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зал славы | Mark Egly Golf`)
};

const tr_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Şöhretler Müzesi | Mark Egly Golf`)
};

const hi_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हॉल ऑफ फेम | Mark Egly Golf`)
};

const id_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Balai Kehormatan | Mark Egly Golf`)
};

const ms_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dewan Kemasyhuran | Mark Egly Golf`)
};

const cs_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Síň slávy | Mark Egly Golf`)
};

const el_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πάνθεον Διασήμων | Mark Egly Golf`)
};

const he_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היכל התהילה | Mark Egly Golf`)
};

const af_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eregalery | Mark Egly Golf`)
};

const hu_hof_meta_title = /** @type {(inputs: Hof_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hírességek Csarnoka | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Hall of Fame \| Mark Egly Golf" |
*
* @param {Hof_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const hof_meta_title = /** @type {((inputs?: Hof_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_hof_meta_title(inputs)
	if (locale === "de") return de_hof_meta_title(inputs)
	if (locale === "zh") return zh_hof_meta_title(inputs)
	if (locale === "ar") return ar_hof_meta_title(inputs)
	if (locale === "fr") return fr_hof_meta_title(inputs)
	if (locale === "vi") return vi_hof_meta_title(inputs)
	if (locale === "sw") return sw_hof_meta_title(inputs)
	if (locale === "th") return th_hof_meta_title(inputs)
	if (locale === "bs") return bs_hof_meta_title(inputs)
	if (locale === "ja") return ja_hof_meta_title(inputs)
	if (locale === "ko") return ko_hof_meta_title(inputs)
	if (locale === "pt") return pt_hof_meta_title(inputs)
	if (locale === "it") return it_hof_meta_title(inputs)
	if (locale === "sv") return sv_hof_meta_title(inputs)
	if (locale === "nl") return nl_hof_meta_title(inputs)
	if (locale === "da") return da_hof_meta_title(inputs)
	if (locale === "nb") return nb_hof_meta_title(inputs)
	if (locale === "fi") return fi_hof_meta_title(inputs)
	if (locale === "pl") return pl_hof_meta_title(inputs)
	if (locale === "ru") return ru_hof_meta_title(inputs)
	if (locale === "tr") return tr_hof_meta_title(inputs)
	if (locale === "hi") return hi_hof_meta_title(inputs)
	if (locale === "id") return id_hof_meta_title(inputs)
	if (locale === "ms") return ms_hof_meta_title(inputs)
	if (locale === "cs") return cs_hof_meta_title(inputs)
	if (locale === "el") return el_hof_meta_title(inputs)
	if (locale === "he") return he_hof_meta_title(inputs)
	if (locale === "af") return af_hof_meta_title(inputs)
	if (locale === "hu") return hu_hof_meta_title(inputs)
	return en_hof_meta_title(inputs)
});